<template>
  <div
    class="overview"
    data-cy="league-overview"
  >
    <a
      v-if="isSuperAdmin() && false"
      role="button"
      class="edit-btn"
      data-cy="league-edit-btn"
      data-toggle="modal"
      data-target="#Modify-League-Info"
    >
      <i
        class="far fa-edit"
        aria-hidden="true"
      />
    </a>

    <h4>{{ $t('JSON.league') }}</h4>
    <p>
      <router-link :to="navigate(league.url)">
        {{ league.name }} ({{ league.teamsCount }} {{ $t('JSON.teams') }})
      </router-link>
    </p>

    <h4>{{ $t('JSON.category') }}</h4>
    <p>
      <router-link :to="navigate(league.category.url)">
        {{ league.category.description }}
      </router-link>
    </p>

    <h4>{{ $t('JSON.region') }}</h4>
    <p>
      <router-link :to="navigate(league.region.url)">
        {{ league.region.name }}
      </router-link>
    </p>

    <template v-if="league.divisions.length > 0">
      <h4>{{ $t("JSON.divisions") }}</h4>
      <ul>
        <li
          v-for="(division, key) in league.divisions"
          :key="key"
        >
          <router-link :to="navigate(`${division.url}`)">
            <span class="tw-invisible">x</span>{{ division.name }} <span class="tw-text-xs">({{ division.teamsCount }} {{ $t("JSON.teams") }})</span>
          </router-link>
        </li>
      </ul>
    </template>

    <div v-if="currentSeason === ongoingSeason">
      <h4>{{ $t('JSON.supervisors') }}</h4>
      <template v-if="league.supervisors.length > 0">
        <ul>
          <li
            v-for="(supervisor, key) in league.supervisors"
            :key="key"
          >
            <router-link :to="navigate(`${supervisor.url}`)">
              <span
                class="tw-invisible"
              >x</span>{{ supervisor.username }}
            </router-link>
          </li>
        </ul>
      </template>
      <template v-else>
        {{ $t('JSON.none') }}
      </template>
    </div>

    <h4>
      <a
        role="button"
        class="add-favorite"
        @click="toggleLike()"
      >
        <i
          :class="favoriteClass"
          aria-hidden="true"
        />&nbsp; {{ $t('JSON.add-to-favorites') }}
      </a>
    </h4>

    <h4 v-if="currentSeason === ongoingSeason">
      <a
        role="button"
        class="supervise-league"
        @click="toggleSupervise()"
      >
        <i
          :class="superviseClass"
          aria-hidden="true"
        />&nbsp; {{ $t('JSON.supervise') }}
      </a>
    </h4>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {

  props: {
    league: {
      type: Object,
      default: () => ({}),
    },
    leagueLiked: {
      type: Object,
      default: () => ({}),
    },
    leagueSupervised: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...sync([
      'general/ongoingSeason', //
      'general/currentSeason',
      'general/currentSeasonId',
      'general/currentRegionId',
      'general/currentCategoryId',
      'general/currentTeamId',
    ]),

    favoriteClass() {
      return this.leagueLiked.status ? 'fas fa-star' : 'far fa-star';
    },

    superviseClass() {
      return this.leagueSupervised.status ? 'fas fa-star' : 'far fa-star';
    },
  },

  methods: {
    toggleLike() {
      if (this.isLoggedIn()) {
        axios
          .post('/api/v1/league/like', {
            sid: this.currentSeasonId,
            cid: this.currentCategoryId,
            rid: this.currentRegionId,
          })
          .then(() => {
            Bus.$emit('refresh_league_following');
          });
      }
    },

    toggleSupervise() {
      if (this.isLoggedIn()) {
        axios
          .post('/api/v1/league/supervise', {
            sid: this.currentSeasonId,
            cid: this.currentCategoryId,
            rid: this.currentRegionId,
          })
          .then(() => {
            Bus.$emit('refresh');
            Bus.$emit('refresh_league_supervising');
          });
      }
    },
  },
};
</script>
